/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { DataContextProvider } from '@forge/data-connector';
import UtilityCostGraphComponent from './UtilityCostGraphComponent/UtilityCostGraphComponent';
import IEnergyManagementProps from '../IEnergyManagementProps';
import { Card } from '@scuf/common';
import descriptors from '../../../locales/en-US/descriptors';
import '../../../scss/KPICardTheme.scss';
import { ContextProvider, updateApiConfig } from '../../../context/ApiContext';
import { withLocalization } from '../../../locales/withLocalization';

const UtilityCostGraphWidget = (props: IEnergyManagementProps) => {
  const { connectorConfig, requestContext, emaasContext } = props;
  const d = descriptors.energyManagement;
  return (
    <ContextProvider
      value={updateApiConfig({
        connectorConfig,
        ...emaasContext
      })}
    >
      <DataContextProvider config={connectorConfig}>
        <div
          className={`utility-container kpi-card-common ${
            emaasContext?.graphType === 'lineGraph' ||
            emaasContext?.graphType === 'barGraph'
              ? 'energy-graph-lineGraph'
              : 'energy-graph'
          }`}
        >
          <Card>
            <Card.Content className="kpi-content-container">
              <UtilityCostGraphComponent requestContext={requestContext} />
            </Card.Content>
          </Card>
        </div>
      </DataContextProvider>
    </ContextProvider>
  );
};

export default withLocalization<IEnergyManagementProps>(UtilityCostGraphWidget);
